import { supabaseClient } from '../supabase'
import baseDataProvider from '../supabase/baseDataProvider'

const eventsDataProvider = {
  ...baseDataProvider,
  getList: async (resource, params) => {
    resource = params?.meta?.useView ? 'events_view' : 'events'
    let result
    
    if (resource === 'events' && params.filter?.schools_ids_in) {
      const schoolId = params.filter.schools_ids_in
      const modifiedParams = { ...params }
      
      // Remove the custom filter
      delete modifiedParams.filter.schools_ids_in
      
      // Build the query
      let query = supabaseClient
        .from('events')
        .select('*')
        .or(`schools_ids.cs.["${schoolId}"]`)
      
      // Apply other filters
      Object.keys(modifiedParams.filter).forEach(key => {
        const value = modifiedParams.filter[key]
        if (key === 'current_year_id') {
          query = query.eq('current_year_id', value)
        }
        // Add other filter conditions as needed
      })
      
      // Apply sorting
      const sortField = params.sort?.field || 'date'
      const sortOrder = params.sort?.order === 'ASC' ? true : false
      query = query.order(sortField, { ascending: sortOrder })
      
      // Apply pagination
      const page = params.pagination?.page || 1
      const perPage = params.pagination?.perPage || 10
      query = query.range(
        (page - 1) * perPage,
        page * perPage - 1
      )
      
      const { data, error } = await query
      
      if (error) throw error
      
      result = {
        data: data || [],
        total: data?.length || 0
      }
      
      return result
    }
   
    return await baseDataProvider.getList(resource, params)
  }
}

export const dataProvider = eventsDataProvider